import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageClaimComment } from '@/views/screens/Claims/types';

export interface GetClaimNotesRequestParams {
  claimKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface ClaimNotesResponse {
  data: LossAndDamageClaimComment[];
  nextPage?: number;
  totalRows: number;
}

export const PAGE_SIZE_DEFAULT = 10;

export const getClaimNotesAPI = (params: GetClaimNotesRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      claimKey: params.claimKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'SequenceNo',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimComment`,
  });
};

export const fetchClaimNotes = async (params: GetClaimNotesRequestParams): Promise<ClaimNotesResponse> => {
  const response: AxiosResponse<ClaimNotesResponse> = await getClaimNotesAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const totalPages = Math.ceil(Number(data.totalRows ?? 0) / pageSize);
  const hasMore = Number(params.pageIndex) < totalPages;

  return {
    ...data,
    nextPage: hasMore ? Number(params.pageIndex) + 1 : undefined,
  };
};
